export const ZENDESK_CHAT_PARTNER = 'zendeskChatPartner';
/**
 * key: partner slug
 */
export const ZENDESK_CHAT_APP_ID: Partial<Record<string, string>> = {
  revolut: '517074fc-dd89-474e-9f5f-adf6b35d570c',
};
